module.exports = __webpack_public_path__ + "static/media/delete.87778221.svg";